import React from 'react';

import { ProductPercentageCard } from '../ProductPercentageCard';

export const Top15ProductsItem = ({ item, index }) => {
  return (
    <>
      <ProductPercentageCard
        loading={false}
        color="brand.tertiary.principal"
        product={{
          position: index + 1,
          name: item.product,
          value: item.amount,
          type: item.type,
          maxAmount: item.maxAmount,
        }}
      />
    </>
  );
};
